export const STATISTICS = {
    DATE_FORMAT: 'YYYY-MM-DD',
};

export const MAX_PAGE_SIZE_FOR_COMPARISON = 10;
export const MAX_ITEM_COUNT_FOR_EXPORT = 1000;
